import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Card } from '@totalsoft/rocket-ui';
import { LocalOffer } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { emptyString } from 'constants/defaultValues';
import { CascoHistoryContentWrapper } from './CascoOffersHistoryStyle';

const CascoQuotationsHistoryComponent = ({ loading, cascoQuotationsHistory, currencyCode }) => {
  const { t } = useTranslation();

  return (
    !loading &&
    cascoQuotationsHistory &&
    cascoQuotationsHistory.length > 0 &&
    cascoQuotationsHistory.map((quotation, index) => (
      <div key={index}>
        <Card icon={LocalOffer} title={quotation.conventionName}>
          <CascoHistoryContentWrapper container item xs={12} spacing={1} px={1}>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.Header.InsurerName')}:</strong> <span>{quotation.insurerName}</span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.Header.PeriodMonth')}:</strong>
              <span>{quotation.period}</span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.Header.InsuranceAmount')}:</strong>
              <span>
                {quotation.baseInsuranceAmount
                  ? `${t('DECIMAL2', { number: quotation.baseInsuranceAmount || emptyString })} ${currencyCode}`
                  : 'N/A'}
              </span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.History.TotalInsuranceAmountHistory')}:</strong>
              <span>
                {quotation.totalInsuranceAmount
                  ? `${t('DECIMAL2', { number: quotation.totalInsuranceAmount || emptyString })} ${currencyCode}`
                  : 'N/A'}
              </span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.History.PartialDamageDeductibleAmountHistory')}:</strong>
              <span>
                {quotation.partialDamageDeductibleAmount
                  ? `${t('DECIMAL2', {
                      number: quotation.partialDamageDeductibleAmount || emptyString
                    })} ${currencyCode}`
                  : 'N/A'}
              </span>
            </Grid>

            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.History.TotalDamageDeductiblePercentHistory')}:</strong>
              <span>{quotation.totalDamageDeductiblePercent || 'N/A'}</span>
              {'%'}
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.Header.DiscountAmountLabel')}:</strong>
              <span>
                {quotation.discountAmount ? `${t('DECIMAL2', { number: quotation.discountAmount || emptyString })} ${currencyCode}` : 'N/A'}
              </span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.Header.DiscountAmountLabel')}:</strong>
              <span>{quotation.discountPercent || 'N/A'}</span>
              {'%'}
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.Header.Periodicity')}:</strong>
              <span>{quotation.periodicity || 'N/A'}</span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.History.InsuredAmount')}:</strong>
              <span>
                {quotation.insuredAmount ? `${t('DECIMAL2', { number: quotation.insuredAmount || emptyString })} ${currencyCode}` : 'N/A'}
              </span>
            </Grid>
            <Grid container item xs={12} sm={6} md={4} lg={3}>
              <strong>{t('Offer.Edit.Casco.History.QuotationDate')}:</strong>
              <span>
                {t('DATE_FORMAT', {
                  date: { value: quotation.quotationDate, format: 'DD.MM.YYYY HH:mm:ss' }
                }) || 'N/A'}
              </span>
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <strong>{t('Offer.Edit.Casco.Risks.Title')}:</strong>
              {quotation.risks &&
                quotation.risks.length > 0 &&
                quotation.risks.map(
                  (risk, index) => risk.selected && <Chip icon={<CheckCircleIcon />} key={index} label={risk.riskName} size='small' />
                )}
              {quotation.risks && quotation.risks.length >= 0 && !quotation.risks.some(risk => risk?.selected) && (
                <span>
                  <Chip label={t('Offer.Edit.Casco.Risks.NoRisksSelected')} size='small' />
                </span>
              )}
            </Grid>
            <Grid item container xs={12} alignItems='center'>
              <strong>{t('Offer.Edit.Casco.Coefficients.Title')}:</strong>
              {quotation.coefficients &&
                quotation.coefficients.length > 0 &&
                quotation.coefficients.map((coefficient, index) => {
                  return (
                    <>
                      {coefficient?.details?.some(detail => detail.selected) && (
                        <i>
                          {coefficient.additionalDataName}
                          {':'}
                        </i>
                      )}

                      <span key={index}>
                        {coefficient?.details &&
                          coefficient?.details?.map(
                            (detail, index) =>
                              detail.selected && (
                                <span key={index}>
                                  <Chip icon={<CheckCircleIcon />} key={index} label={detail.detailName} size='small' />
                                </span>
                              )
                          )}
                      </span>
                    </>
                  );
                })}
              {quotation.coefficients &&
                quotation.coefficients.length >= 0 &&
                !quotation.coefficients.some(coefficient => coefficient?.details?.some(detail => detail?.selected)) && (
                  <span>
                    <Chip label={t('Offer.Edit.Casco.Coefficients.NoCoefficientDetailsSelected')} size='small' />
                  </span>
                )}
            </Grid>
          </CascoHistoryContentWrapper>
        </Card>
      </div>
    ))
  );
};

CascoQuotationsHistoryComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  cascoQuotationsHistory: PropTypes.array,
  currencyCode: PropTypes.string
};

export default CascoQuotationsHistoryComponent;
